module.exports = __webpack_public_path__ + "static/media/bg404.c6e9818b.png";